import router, { setRouterAuthRedirect } from "@/router.js"
import routes from "@/routes.js"

import isFunction from "lodash/isFunction"

import { eventBus } from "@/plugins/eventBus.js"

import { useUserSessionStore } from "@/store/userSession.js"
import { useGroupsStore } from "@/store/groups.js"
import { useConfigurationStore } from "@/store/configuration.js"

export const checkEmailConfirmation = async () => {
  const configurationStore = useConfigurationStore()
  const userSessionStore = useUserSessionStore()

  let result = false
  if (!configurationStore.configuration.emailConfirmationEnabled || !userSessionStore.emailConfirmationRequired) {
    result = true
  } else {
    await userSessionStore.setUserData()
    result = !userSessionStore.emailConfirmationRequired
  }

  eventBus.$emit("email-confirmation-required", !result)
  return result
}

export const checkPostInteractionAuth = ({ post, callback, route }) => {
  const userSessionStore = useUserSessionStore()
  if (userSessionStore.isLoggedIn) {
    const groupsStore = useGroupsStore()
    if (!groupsStore.isUserMember(post.group.key)) {
      return { groupToJoinKey: post.group.key }
    } else if (isFunction(callback)) {
      callback()
    }
  } else {
    setRouterAuthRedirect(route)
    router.push({ name: routes.LOGIN })
  }

  return { groupToJoinKey: null }
}

export const getRequiredSubscriptionPlans = (content) => {
  const userSessionStore = useUserSessionStore()
  const contentPlanRestrictions = (content?.subscription_plan_restrictions || []).map((p) => p.subscription)
  let requiredPlans = (userSessionStore.paywallData?.plans || []).filter((p) => contentPlanRestrictions.find((r) => r.name === p.name))

  if (!requiredPlans.length && (content.subscriber_only || content.premium_only) && userSessionStore.paywallData?.plans?.length) {
    requiredPlans = userSessionStore.paywallData?.plans
  }

  if (!requiredPlans.length || requiredPlans.find((p) => p.name === userSessionStore.ownedPaywallPlan?.subscription_name)) {
    return []
  } else {
    return requiredPlans
  }
}
